import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { EditorialReviewEntities } from 'client/data/models/editorial-review';
import { SafetyEntities, buildSafetyRatingsPathByParams, SafetyModel } from 'client/data/models/safety';
import { buildMMYGenericFeaturesPath, VehicleEntities, VehicleModel } from 'client/data/models/vehicle-v2';
import { MENU_HASH } from 'site-modules/shared/constants/core-page/menu-hash';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { SafetyGenericFeatures, FEATURES_PRIORITY } from './safety-generic-features/safety-generic-features';
import { SafetyRatings } from './safety-ratings';
import { SafetyFeatures } from './safety-features';
import { isNhtsaRatingsEmpty } from './utils';

import './safety.scss';

export function SafetyUI({
  modelName,
  ratings = {},
  editorialReview = {},
  safetyGenericFeatures = null,
  params,
  hasSeparator = true,
}) {
  const nhtsaRatings = get(ratings, 'nhtsaRatings');
  const iihsRatings = get(ratings, 'iihsRatings');
  const safetyFeatures = get(editorialReview, 'safetyFeatures');

  const hasSafetyFeatures = !isEmpty(safetyFeatures);

  if (
    !hasSafetyFeatures &&
    isEmpty(safetyGenericFeatures) &&
    isEmpty(iihsRatings) &&
    isNhtsaRatingsEmpty(nhtsaRatings)
  ) {
    return null;
  }

  return (
    <ScrollElement
      id={MENU_HASH.SAFETY}
      tag="section"
      className="mb-2 core-safety text-gray-darker"
      data-tracking-parent="edm-entry-safety"
    >
      <h2 className="text-start heading-3 mb-0_5">Safety</h2>
      {hasSafetyFeatures && (
        <SafetyFeatures modelName={modelName} safetyFeatures={safetyFeatures} isUsed={params.isUsed} />
      )}
      {!hasSafetyFeatures && !isEmpty(safetyGenericFeatures) && (
        <SafetyGenericFeatures safetyGenericFeatures={safetyGenericFeatures} modelName={modelName} />
      )}
      <SafetyRatings nhtsaRatings={nhtsaRatings} iihsRatings={iihsRatings} />
      {hasSeparator && <hr className="mt-1_5 mb-2" />}
    </ScrollElement>
  );
}

SafetyUI.propTypes = {
  modelName: PropTypes.string.isRequired,
  params: CorePageParams.isRequired,
  editorialReview: EditorialReviewEntities.EditorialReview,
  safetyGenericFeatures: PropTypes.arrayOf(VehicleEntities.GenericFeature),
  ratings: SafetyEntities.Ratings,
  hasSeparator: PropTypes.bool,
};

export const Safety = connectToModel(SafetyUI, {
  ratings: bindToPath(buildSafetyRatingsPathByParams, SafetyModel),
  safetyGenericFeatures: bindToPath(
    ({ params, editorialReview }) =>
      isEmpty(get(editorialReview, 'safetyFeatures')) && buildMMYGenericFeaturesPath(params),
    VehicleModel,
    genericFeatures => get(genericFeatures, 'Safety', []).filter(({ niceId }) => FEATURES_PRIORITY.includes(niceId))
  ),
});
